import React from 'react';
import { DropDownFilter } from 'framework/list';
import { RECONCILIATION_TYPES_OPTIONS } from '../../useReconciliationService';
import { EnumDropdown } from 'framework/form';

type ReconciliationDropdownFilterProps = {
  source: string;
  label: string;
};

const ReconciliationDropdownFilter = (props: ReconciliationDropdownFilterProps) => {
  return (
    <DropDownFilter {...props}>
      <EnumDropdown {...props} options={RECONCILIATION_TYPES_OPTIONS} />
    </DropDownFilter>
  );
};

export default ReconciliationDropdownFilter;
